import api from "@/lib/axios";

export default {
    checkSlugAvailability: async (slug, vacancyId = null) => {
        try {
            let endpoint = '/vacancy/check-slug';

            if (vacancyId) {
                endpoint = `/vacancy/${vacancyId}/check-slug`;
            }

            const response = await api.post(endpoint, { slug });
            return response.data;
        } catch (error) {
            if (error.response && error.response.data) {
                return error.response.data;
            }
            throw new Error("Failed to check slug availability: " + error.message);
        }
    },

    checkCampaignSlugAvailability: async (slug, campaignId = null) => {
        try {
            let endpoint = '/campaign/check-slug';

            if (campaignId) {
                endpoint = `/campaign/${campaignId}/check-slug`;
            }

            const response = await api.post(endpoint, { slug });
            return response.data;
        } catch (error) {
            if (error.response && error.response.data) {
                return error.response.data;
            }
            throw new Error("Failed to check campaign slug availability: " + error.message);
        }
    },
};